module.exports = __webpack_public_path__ + "static/img/小米 MIX Flip.dcc14bff.png";